export const environment = {
  production: false,
   baseUrl:'https://betaapi-suzuki.mint360.in/api/v1/',
   masterUrl:'https://betaapi-suzuki.mint360.in/api/v1/admin/master/',
   bucketUrl: 'https://d1sn8rvxrcf2ob.cloudfront.net/assets',
  //baseUrl:'https://suzuki-api.mint360.in/api/v1/',
  //masterUrl:'https://suzuki-api.mint360.in/api/v1/admin/master/',
  //bucketUrl: 'https://d1sn8rvxrcf2ob.cloudfront.net/assets',
  mintBucketurl:'https://d17p6t0a43h3is.cloudfront.net',
  AWS_ACCESS_KEY_ID: 'AKIA3N64O5CJ6U22UHHC',
  AWS_SECRET_ACCESS_KEY: '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',
  SQS_QUEUE_URL: 'https://sqs.ap-south-1.amazonaws.com/785904494739/adminReportQueue',
  SQS_QUEUE_NAME: 'adminReportQueue'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
